import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import ConfirmationModal from "components/framework/modals/ConfirmationModal";

type Props = {
  closeModal: () => void;
  confirmCallback: () => void;
};

export default function DeleteLastPhoneNumberModal(props: Props) {
  const intl = useIntl();

  const handleDelete = () => {
    props.confirmCallback();
    props.closeModal();
  };

  return (
    <ConfirmationModal
      confirmCallback={handleDelete}
      closeModal={props.closeModal}
      title={intl.formatMessage({ id: "orders.portIn.stepTwo.deleteLastPhoneNumberModal.title" })}
      confirmButtonText={intl.formatMessage({
        id: "orders.portIn.stepTwo.deleteLastPhoneNumberModal.submitDelete"
      })}>
      <p>
        <FormattedMessage id="orders.portIn.stepTwo.deleteLastPhoneNumberModal.text" />
      </p>
    </ConfirmationModal>
  );
}
